var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNotification = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0206 2.90991C8.71058 2.90991 6.02058 5.59991 6.02058 8.90991V11.7999C6.02058 12.4099 5.76058 13.3399 5.45058 13.8599L4.30058 15.7699C3.59058 16.9499 4.08058 18.2599 5.38058 18.6999C9.69058 20.1399 14.3406 20.1399 18.6506 18.6999C19.8606 18.2999 20.3906 16.8699 19.7306 15.7699L18.5806 13.8599C18.2806 13.3399 18.0206 12.4099 18.0206 11.7999V8.90991C18.0206 5.60991 15.3206 2.90991 12.0206 2.90991Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0195 19.0601C15.0195 20.7101 13.6695 22.0601 12.0195 22.0601C11.1995 22.0601 10.4395 21.7201 9.89953 21.1801C9.35953 20.6401 9.01953 19.8801 9.01953 19.0601",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNotification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_notification.6c74d48d8a62ff75770adaeb6873321e.svg";